import axios from 'axios';

const API_URL = '/api/visitors';

export interface VisitorStats {
    today: number;
    total: number;
    overseas: number;
    overseasRate: number;
    counted: boolean;
}

export const trackVisitor = async () => {
    const response = await axios.post(`${API_URL}/track`, null, {
        headers: {
            'X-Visitor-Path': window.location.pathname,
        },
    });
    return response.data as VisitorStats;
};
